import { api_subscribe_user_path, api_update_subscription_for_cbpt_path } from '@routes';

import request from './request';

export interface SelectedOffer {
  description: string;
  billingFrequency: string;
  code: string;
  currentPrice: number;
  isBestValue: boolean;
  isPro: boolean;
  offsetTop: number;
  originalPrice: number;
  title: string;
}

export interface OfferOption extends Omit<SelectedOffer, ''> {
  billingFrequencyOverride: string;
  currentPriceDisplayOverride: number;
  description: string;
  header: string;
  listOfBenefits?: string[];
  originalPriceDisplayOverride?: number;
  subHeader: string;
}

export type SelectedHorizontalOffer = Omit<SelectedOffer, 'offsetTop'>;

export interface OfferOptionHorizontal extends OfferOption, SelectedHorizontalOffer {}

export interface SubscribeUserParams {
  modal?: string;
  page: string;
  code: string;
  presented_offer_codes: string[];
  referer: string;
  referring_article_id?: string;
  referrer_guid?: string;
  source: string;
  subscription_id?: string;
}

export interface SubscribeUserResponse {
  affiliation: string;
  email: string;
  initialSubscriptionPrice: string;
  offerCode: string;
  productSku: string;
  redirectTo: string;
  stripePlanName: string;
  subscriptionVariant: string;
  trackConversion: boolean;
  userId: number;
}

export async function subscribeUser(params: SubscribeUserParams): Promise<SubscribeUserResponse> {
  const response = await request('post', api_subscribe_user_path(params));
  return response;
}

export async function updateCbptUserSubscription(
  params: SubscribeUserParams
): Promise<SubscribeUserResponse> {
  const response = await request('put', api_update_subscription_for_cbpt_path(params));
  return response;
}
